<template>
  <div>
    <a href="#main-content" class="visually-hidden-focusable position-absolute top-0 start-0 p-2 bg-white text-dark" style="z-index:9999">Skip to main content</a>
    <ApplicationHeader />

    <!--- This blocks router/child components from loading until accesstoken is loaded, or possibly errored out-->
    <main id="main-content" tabindex="-1">
      <LoadingAccessToken v-if="sessionStore.accessToken === '' || sessionStore.uvid == '' " />
      <InvalidSession v-else-if="sessionStore.invalidAccessToken || sessionStore.session_issues" />
      <router-view v-else />
    </main>

    <div class="vstack fixed-bottom">
      <error-messages v-for="(error_message, error_index) in sessionStore.error_messages" :key="error_index" :error_message="error_message" :error_index="error_index"/>
    </div>


  </div>
</template>


<script lang="ts">

//const toTimestamp = (strDate : string) => Date.parse(strDate);

import axios from 'axios';

import { useSessionStore } from './stores/SessionStore'
import { useInfotextStore } from '@/stores/InfotextStore';

import { AuthService } from './services/auth'
import { EnvService } from './services/env'

import { defineComponent, onMounted, reactive } from 'vue'
import { AccountInfo } from '@azure/msal-common';

import ApplicationHeader from './components/ApplicationHeader.vue'

import InvalidSession from './components/common/InvalidSession.vue'
import LoadingAccessToken from './components/common/LoadingAccessToken.vue'
import ErrorMessages from './components/common/ErrorMessages.vue'

export default defineComponent({
  setup() {
    
    const authService = reactive(new AuthService())
    const sessionStore = useSessionStore()
    const infotextStore = useInfotextStore()

    const envService = new EnvService()

    onMounted(async () => {
    })
    

    return { authService, sessionStore, infotextStore, envService}
  },
  data() {
    return {
      app_title : "",
      app_name : "",
      backend_path : "",
      environment: ""
    }
  },
  name: 'App',
  components: { ApplicationHeader, InvalidSession, LoadingAccessToken, ErrorMessages },

  async mounted() {
    await this.authService.loadAuthModule()


    // had to build a service since the process.env.... object shows a lint error
    this.sessionStore.app_title = this.envService.getAttribute("VUE_APP_TITLE")
    this.sessionStore.app_name = this.envService.getAttribute("VUE_APP_NAME")
    this.sessionStore.backend_path = this.envService.getAttribute("VUE_APP_BACKEND_PATH")
    
    await this.renew_access_token()
    await this.refresh_environment()

    // if(this.backend_path && !this.sessionStore.invalidAccessToken){
    //   let {data} = (await axios.get(`${this.backend_path}/environment`, this.authService.auth_header())).data;
    //   this.environment = data.environment
    // }

    setInterval(() => {
      // don't renew access token if there are any session issues
      if(this.sessionStore.session_issues) return false
      this.renew_access_token()
    }, 30000);

    // setInterval(() => {
    //   this.refresh_environment()
    // }, 10000);
  },
  methods: {
    
      async refresh_environment(){

        try {
          // acts as a keep-alive and detects network/session issues
          let {data} = (await axios.get(`${this.sessionStore.backend_path}/environment`, this.sessionStore.auth_header)).data;
          this.sessionStore.environment = data.environment
          this.sessionStore.dynamic_roles = data.roles
          this.sessionStore.session_issues = false
        } catch (err) {
          console.log("Error: Unable to contact application server - ", err)
          this.sessionStore.session_issues = true
        }
      },

      async renew_access_token () {
        await this.authService.acquireAccessToken()
      }
  },

  watch: {

    'authService.username': function() {
      // since the username is returned in the format of uvid@uvu.edu - but then moved it down to the accessToken watch, since sometimes people can login with their named account - i.e. david.nielsen@uvu.edu
      //this.sessionStore.uvid = username.indexOf('@') > 0 ? username.substr(0, username.indexOf('@')) : ''
      const usernames = this.authService.getAccountsUserNames()
      this.sessionStore.updateAccountUserNames(usernames)

      const account: AccountInfo | undefined = this.authService.getAccount()
      this.sessionStore.updateUserAccount(account)
    },

    'authService.accessToken' : function(accessToken) {
      
      const claims = JSON.parse(atob(accessToken.split('.')[1]))
      const upn = claims.upn
      this.sessionStore.uvid = upn.indexOf('@') > 0 ? upn.substr(0, upn.indexOf('@')) : ''
      
      this.sessionStore.updateAccessToken(accessToken)
    },

    'sessionStore.app_title' : function(title) {
      const pageTitle = this.$route?.meta?.title
      document.title = pageTitle ? `${pageTitle} | ${title}` : title
    },

    '$route' : function(to) {
      const pageTitle = to?.meta?.title
      const appTitle = this.sessionStore.app_title
      document.title = pageTitle && appTitle ? `${pageTitle} | ${appTitle}` : appTitle || 'Section Authorization'
    },

  }

});
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 0;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.bg-uvu {
    background-color: #00843e !important;
}
</style>
